import { render, staticRenderFns } from "./footer_bar.vue?vue&type=template&id=7194a6b8"
import script from "./footer_bar.vue?vue&type=script&lang=js"
export * from "./footer_bar.vue?vue&type=script&lang=js"
import style0 from "./footer_bar.vue?vue&type=style&index=0&id=7194a6b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports